import { render, staticRenderFns } from "./CbsPaycalTable.vue?vue&type=template&id=379003a7&scoped=true"
import script from "./CbsPaycalTable.vue?vue&type=script&lang=js"
export * from "./CbsPaycalTable.vue?vue&type=script&lang=js"
import style0 from "./CbsPaycalTable.vue?vue&type=style&index=0&id=379003a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379003a7",
  null
  
)

export default component.exports